import { createRouter, createWebHistory } from "vue-router";
import ConnectInternetView from "../views/ConnectInternetView.vue";
import ReferFriendView from "../views/ReferFriendView.vue";
import RequestSuccessView from "../views/RequestSuccessView.vue";
import RequestErrorView from "../views/RequestErrorView.vue";
import HomeView from "../views/HomeView.vue";
import Promotion6plus1View from "../views/promotions/Promotion6plus1View.vue";
import Promotion12plus3View from "../views/promotions/Promotion12plus3View.vue";
import PromotionReferFriendView from "../views/promotions/PromotionReferFriendView.vue";
import MobileAppView from "../views/MobileAppView.vue";
import ShopView from "../views/ShopView.vue";
import ProductView from "../views/ProductView.vue";
import CheckoutView from "../views/CheckoutView.vue";
import CheckoutErrorView from "../views/CheckoutErrorView.vue";
import CheckoutSuccessView from "../views/CheckoutSuccessView.vue";
import DefaultLayout from "@/layouts/DefaultLayout.vue";

const routes = [
  {
    path: "/",
    name: "home",
    component: HomeView,
    meta: {
      layout: DefaultLayout,
    },
  },
  {
    path: "/connect-internet",
    name: "connect-internet",
    component: ConnectInternetView,
    meta: { layout: DefaultLayout },
  },
  {
    path: "/refer-friend",
    name: "refer-friend",
    component: ReferFriendView,
    meta: { layout: DefaultLayout },
  },
  {
    path: "/request-success",
    name: "request-success",
    component: RequestSuccessView,
    meta: { layout: DefaultLayout },
  },
  {
    path: "/request-error",
    name: "request-error",
    component: RequestErrorView,
    meta: { layout: DefaultLayout },
  },
  {
    path: "/promotions/6-plus-1",
    name: "6-plus-1-promotion",
    component: Promotion6plus1View,
    meta: { layout: DefaultLayout },
  },
  {
    path: "/promotions/12-plus-3",
    name: "12-plus-3-promotion",
    component: Promotion12plus3View,
    meta: { layout: DefaultLayout },
  },
  {
    path: "/promotions/refer-friend",
    name: "refer-friend-promotion",
    component: PromotionReferFriendView,
    meta: { layout: DefaultLayout },
  },
  {
    path: "/mobile-app",
    name: "mobile-app",
    component: MobileAppView,
    meta: { layout: DefaultLayout },
  },
  {
    path: "/shop",
    name: "shop",
    component: ShopView,
    meta: { layout: DefaultLayout },
  },
  {
    path: "/shop/product/:id",
    name: "product",
    component: ProductView,
    meta: { layout: DefaultLayout },
  },
  {
    path: "/checkout",
    name: "checkout",
    component: CheckoutView,
    meta: { layout: DefaultLayout },
  },
  {
    path: "/checkout-success",
    name: "checkout-success",
    component: CheckoutSuccessView,
    meta: { layout: DefaultLayout },
  },
  {
    path: "/checkout-error",
    name: "checkout-error",
    component: CheckoutErrorView,
    meta: { layout: DefaultLayout },
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
